import type { RouteRecordRaw } from 'vue-router';

import { lazyPage } from '@/shared/lib';
import { RouterPages, RouterPaths } from '@/shared/router';

const errorRoutes: RouteRecordRaw[] = [
  {
    component: lazyPage(() => import('@/pages/error'), 'ApplicationErrorPage'),
    name: RouterPages.ERROR,
    path: RouterPaths.ERROR,
    meta: {
      ignoreAuth: true,
    },
  },
  {
    component: lazyPage(() => import('@/pages/error'), 'NotFoundPage'),
    name: RouterPages.NOT_FOUND,
    path: '/:pathMatch(.*)*',
    meta: {
      ignoreAuth: true,
    },
  },
] as const;

export { errorRoutes };
